import { render, staticRenderFns } from "./CartCard.vue?vue&type=template&id=42ff3da8&scoped=true&"
import script from "./CartCard.vue?vue&type=script&lang=js&"
export * from "./CartCard.vue?vue&type=script&lang=js&"
import style0 from "./CartCard.vue?vue&type=style&index=0&id=42ff3da8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ff3da8",
  null
  
)

export default component.exports